import {
  AfterViewInit,
  Component,
  effect,
  ElementRef,
  EventEmitter,
  inject,
  input,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { SurveyRenderControllerStore } from '../../render-store/render.store';
import { SurveyListOption } from '@hyper-inferno/survey-elements-core';

@Component({
  selector: 'lib-option-open-end',
  standalone: true,
  imports: [],
  templateUrl: './option-open-end.component.html',
  styleUrl: './option-open-end.component.css',
})
export class OptionOpenEndComponent implements AfterViewInit {
  @Input({ required: true }) name!: string;

  @Input({ required: true }) option!: Omit<SurveyListOption, 'created_at' | 'list_id'>;

  isSelected = input.required<boolean>();

  renderStore = inject(SurveyRenderControllerStore);

  @Output() inputChange = new EventEmitter<string>();

  @ViewChild('inputEl') inputEl!: ElementRef<HTMLInputElement>;

  ngAfterViewInit() {
    // Focus instantly when the slotUnder content is rendered
    setTimeout(() => this.inputEl.nativeElement.focus(), 0);
  }

  onInputChange(event: Event) {
    const val = (event.target as HTMLInputElement).value;

    const refName = this.name + '_' + this.option.option_key + '_oe';

    // Update the central store
    this.renderStore.updateOEMapping(this.option.id, refName, val);
    this.inputChange.emit(val);
  }
  flag = false;
  constructor() {
    effect(() => {
      let isSelected = this.isSelected();
      setTimeout(() => {
        // This block is to prevent race condition that prevents oe value from being removed from legacy payload builder
        if (isSelected) {
          this.flag = true;
          this.inputChange.emit(this.inputEl.nativeElement.value);
        } else {
          // Don't trigger if its the first time

          if (this.flag == true) this.inputChange.emit('');
        }
      }, 100);
    });
  }
}
